import React from 'react';
import img8 from '../asserts/image8.jpg'; // Ensure this path is correct
import Footer from '../Footer';

const Regional = () => {
  return (
    <div>
      <p style={{marginRight: "25px",textAlign:"justify", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "25px" }}>
        TISSAA plays a pivotal role in bridging the gap between Alums-led organizations and those in need of support. 
        Many Alums who have founded or lead organizations require assistance with research, human resource development, 
        funding, and documentation, while others with specific expertise are eager to mentor. TISSAA facilitates these connections 
        by bringing together organizations and expert Alums mentors. This partnership helps both parties achieve their goals, with 
        mentors offering guidance and support pro bono, ensuring a sustainable and collaborative relationship that benefits both Alums 
        and the wider community.
      </p>
      {/* Image added at the bottom */}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
        <img 
          src={img8} 
          alt="Regional Partnership" 
          style={{ width: '60%', height: '60%', borderRadius: '10px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', marginBottom: '20px' }} 
        />
      </div>
      <Footer/>
    </div>
  );
};

export default Regional;
